<template>
	<div class="sing-in">
		<div class="sing-in__bg sing-in__bg_1 _ibg-contain">
			<img src="@/assets/img/bg/hero/01.png" />
		</div>
		<div class="sing-in__bg sing-in__bg_2 _ibg-contain">
			<img src="@/assets/img/bg/hero/02.png" />
		</div>
		<div class="sing-in__bg sing-in__bg_3 _ibg">
			<img src="@/assets/img/bg/hero/03.png" />
		</div>
		<div class="sing-in__bg sing-in__bg_4 _ibg-contain">
			<img src="@/assets/img/bg/hero/04.png" />
		</div>
		<div class="sing-in__inner _cnt">
			<div class="sing-in__content">
				<div :class="['sing-in__login', { hidden: !loginContentVisible }]">
					<div class="sing-in__title _h1">{{ $t('Log in') }}</div>
					<div class="sing-in__line _line"><span></span></div>
					<div class="sing-in__form">
						<BaseInput
							class="sing-in__input"
							v-model="email"
							type="email"
							autocomplete="email"
							:label="`${$t('Email')}:`"
						/>
						<BaseInput
							class="sing-in__input"
							v-model="pass"
							type="password"
							:label="`${$t('Password')}:`"
						/>
					</div>
					<button
						class="sing-in__link _link-primary"
						@click="switchToforgotPass"
					>
						{{ $t('Forgot password?') }}
					</button>
					<Transition>
						<p v-if="error" class="sing-in__error">
							{{ error }}
						</p>
					</Transition>
					<BaseButton
						@click="submitLogin"
						:disabled="isSubmitting || email === '' || pass === ''"
						:text="loaderIsVisible ? $t('Logging in') : $t('Log in')"
						class="sing-in__submit _btn-primary"
					/>

					<div class="sing-in__bottom">
						<p class="sing-in__text">
							{{ $t('Don’t have an Account?') }}
						</p>
						<router-link
							class="sing-in__link-up _btn-bordered"
							to="/singup"
							@click="$emit('clearError')"
						>
							{{ $t('Register') }}
						</router-link>
					</div>
				</div>
				<div
					:class="[
						'sing-in__forgot',
						{ hidden: !forgotPassContentVisible },
					]"
				>
					<h2 class="sing-in__title _h2">{{ $t('Forgot password?') }}</h2>
					<div class="sing-in__form">
						<BaseInput
							class="sing-in__input sing-in__input_forgot"
							v-model="email"
							type="email"
							autocomplete="username"
							:label="`${$t('Email')}:`"
						/>
						<Transition>
							<p v-if="successMessage" class="sing-in__success">
								{{ successMessage }}
							</p>
						</Transition>
						<Transition>
							<p v-if="error" class="sing-in__error">
								{{ error }}
							</p>
						</Transition>
						<BaseButton
							@click="submitForgotPass"
							:disabled="isSubmitting || email === ''"
							:text="
								loaderIsVisible
									? `${$t('Recovering')}...`
									: $t('Recover')
							"
							class="sing-in__submit _btn-primary"
						/>

						<div class="sing-in__bottom">
							<p class="sing-in__text">{{ $t('Have account?') }}</p>
							<a
								class="sing-in__link-up _btn-bordered"
								@click="switchToLogin"
							>
								{{ $t('Log in') }}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseInput from '@/components/base/BaseInput.vue';

export default {
	name: 'SigninPage',
	components: { BaseButton, BaseInput },
	props: {
		isAuth: { type: Boolean, required: true },
		error: {
			type: String,
			default: '',
			required: true,
		},
		successMessage: {
			type: String,
			required: true,
		},
		loaderIsVisible: {
			type: Boolean,
			required: true,
		},
		showResendOption: {
			type: Boolean,
			required: true,
		},
	},
	data: function () {
		return {
			isSubmitting: false,
			loginContentVisible: true,
			forgotPassContentVisible: false,
			email: '',
			pass: '',
		};
	},
	watch: {
		isAuth(isNowAuthed) {
			if (
				isNowAuthed &&
				this.$route.path !== '/profile/personal-information'
			) {
				this.$router.push('/profile/personal-information');
			}
		},
	},
	mounted() {
		this.isSubmitting = false;
	},
	methods: {
		resendVerificationEmail() {
			this.$emit('resendVerificationEmail', this.email);
		},
		openSignUp() {
			this.$emit('clearError');
			this.$emit('openSignUp');
		},
		switchToforgotPass() {
			this.$emit('hideResendOption');
			this.$emit('clearError');
			setTimeout(() => {
				this.loginContentVisible = false;
				this.forgotPassContentVisible = true;
			}, 100);
		},
		switchToLogin() {
			this.$emit('hideResendOption');
			this.$emit('clearError');
			setTimeout(() => {
				this.forgotPassContentVisible = false;
				this.loginContentVisible = true;
			}, 100);
		},
		submitLogin() {
			this.isSubmitting = true;
			let loginData = {
				username: this.email,
				password: this.pass,
			};
			this.$emit('login', loginData);
			this.isSubmitting = false;
		},
		submitForgotPass() {
			this.isSubmitting = true;
			let data = {
				email: this.email,
			};
			this.$emit('forgotPass', data);
			this.email = '';
			this.isSubmitting = false;
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.sing-in {
	position: relative;
	min-height: 100vh;
	display: flex;
	align-items: center;
	@include adaptiveValue('padding-top', 100, 75);
	@include adaptiveValue('padding-bottom', 100, 25);
	position: relative;
	overflow: hidden;
	margin-top: -64px;
	@media (max-width: $md1) {
		margin-top: -50px;
	}
	@media (max-width: $md3) {
		&::before {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background-color: var(--bg-fifth-color);
		}
		min-height: fit-content;
	}
	&__bg {
		position: absolute;
		&_1 {
			width: 50%;
			left: 0px;
			bottom: 0px;
			padding-bottom: 14.5%;
			z-index: -1;
		}
		&_2 {
			width: 52.5%;
			left: -3.5%;
			bottom: -4%;
			padding-bottom: 41.5%;
			z-index: -2;
		}
		&_3 {
			width: 100%;
			height: 100%;
			left: -38%;
			z-index: -3;
			bottom: 0px;
		}
		&_4 {
			width: 94.5%;
			height: 94%;
			right: 0px;
			top: 10%;
			z-index: -4;
		}
	}
	&__inner {
		flex: 1 1 auto;
		position: relative;
	}
	&__content {
		margin-left: auto;
		position: relative;
		z-index: var(--base-z-index);
		@include adaptiveValue('max-width', 710, 500, 1470, 768, 1);
		@media (max-width: $md3) {
			margin-right: auto;
		}
	}
	&__forgot,
	&__login {
		&.hidden {
			@include hide-item;
		}
		@media (max-width: $md3) {
			margin: 0 auto;
		}
	}
	&__title,
	&__line {
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
	}

	&__input {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 14, 10);
		}
		&_forgot {
			&:not(:last-child) {
				@include adaptiveValue('margin-bottom', 40, 15);
			}
		}
	}
	&__form {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 15);
		}
	}
	&__link {
		width: fit-content;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 15);
		}
	}

	&__success,
	&__error {
		text-align: center;
		margin-bottom: 8px;
	}
	&__success {
		color: var(--success-color);
	}
	&__error {
		color: var(--error-color);
	}
	&__submit {
		max-width: 220px;
		width: 100%;
		margin: 0 auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 72, 15);
		}
	}
	&__bottom {
		@media (min-width: $md4) {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 20px;
		}
	}
	&__text {
		font-weight: 500;
		@media (max-width: $md4) {
			text-align: center;
			&:not(:last-child) {
				margin-bottom: 10px;
			}
		}
	}
	&__link-up {
		max-width: 220px;
		width: 100%;
		@media (max-width: $md4) {
			margin: 0 auto;
		}
	}
}
</style>
